<template>
    <div>
      <a-drawer :title='title' :visible="visible" v-bind="drawerConfig" :body-style="{ paddingBottom: '80px' }"  @close="onClose">
        <a-form-model ref="ruleForm" :model="form" :rules="rules" v-bind="layout" >
          <template v-if="typeId==1">
            <a-form-model-item ref="seo_title_in" label="seo标题" prop="seo_title_in" :help="formErr.seo_title_in" :validateStatus='!formErr.seo_title_in||formErr.seo_title_in==""?"":"error"' >
              <a-input type="textarea"
                       :maxLength=5000
                       v-model="form.seo_title_in"
                       @change="(e) => { formErr.seo_title_in=''}"
                       @blur="(e) => {  form.seo_title_in = e.target.value.trim();}" />
            </a-form-model-item>
            <a-form-model-item ref="seo_description_in" label="seo描述" prop="seo_description_in" :help="formErr.seo_description_in" :validateStatus='!formErr.seo_description_in||formErr.seo_description_in==""?"":"error"' >
              <a-input type="textarea"
                       :maxLength=5000
                       v-model="form.seo_description_in"
                       @change="(e) => { formErr.seo_description_in=''}"
                       @blur="(e) => {  form.seo_description_in = e.target.value.trim();}" />
            </a-form-model-item>
            <a-form-model-item ref="keyword_in" label="关键词内容描述" prop="keyword_in" :help="formErr.keyword_in" :validateStatus='!formErr.keyword_in||formErr.keyword_in==""?"":"error"' >
              <a-input type="textarea"
                       :maxLength=5000
                       v-model="form.keyword_in"
                       @change="(e) => { formErr.keyword_in=''}"
                       @blur="(e) => {  form.keyword_in = e.target.value.trim();}" />
            </a-form-model-item>
            <a-form-model-item ref="paragraphs_in" label="产品段落描述" prop="paragraphs_in" :help="formErr.paragraphs_in" :validateStatus='!formErr.paragraphs_in||formErr.paragraphs_in==""?"":"error"' >
              <a-input type="textarea"
                       :maxLength=5000
                       v-model="form.paragraphs_in"
                       @change="(e) => { formErr.paragraphs_in=''}"
                       @blur="(e) => {  form.paragraphs_in = e.target.value.trim();}" />
            </a-form-model-item>
            <a-form-model-item ref="company_in" label="公司介绍内容" prop="company_in" :help="formErr.company_in" :validateStatus='!formErr.company_in||formErr.company_in==""?"":"error"' >
              <a-input type="textarea"
                       :maxLength=5000
                       v-model="form.company_in"
                       @change="(e) => { formErr.company_in=''}"
                       @blur="(e) => {  form.company_in = e.target.value.trim();}" />
            </a-form-model-item>
            <a-form-model-item ref="case_in" label="案例描述" prop="case_in" :help="formErr.case_in" :validateStatus='!formErr.case_in||formErr.case_in==""?"":"error"' >
              <a-input type="textarea"
                       :maxLength=5000
                       v-model="form.case_in"
                       @change="(e) => { formErr.case_in=''}"
                       @blur="(e) => {  form.case_in = e.target.value.trim();}" />
            </a-form-model-item>
            <a-form-model-item ref="cert_in" label="证书描述" prop="cert_in" :help="formErr.cert_in" :validateStatus='!formErr.cert_in||formErr.cert_in==""?"":"error"' >
              <a-input type="textarea"
                       :maxLength=5000
                       v-model="form.cert_in"
                       @change="(e) => { formErr.cert_in=''}"
                       @blur="(e) => {  form.cert_in = e.target.value.trim();}" />
            </a-form-model-item>
            <a-form-model-item ref="company_image_in" label="公司图片描述" prop="company_image_in" :help="formErr.company_image_in" :validateStatus='!formErr.company_image_in||formErr.company_image_in==""?"":"error"' >
              <a-input type="textarea"
                       :maxLength=5000
                       v-model="form.company_image_in"
                       @change="(e) => { formErr.company_image_in=''}"
                       @blur="(e) => {  form.company_image_in = e.target.value.trim();}" />
            </a-form-model-item>
          </template>
          <template v-if="typeId==2">
            <a-form-model-item ref="seo_title_in" label="seo标题" prop="seo_title_in" :help="formErr.seo_title_in" :validateStatus='!formErr.seo_title_in||formErr.seo_title_in==""?"":"error"' >
              <a-input type="textarea"
                       :maxLength=5000
                       v-model="form.seo_title_in"
                       @change="(e) => { formErr.seo_title_in=''}"
                       @blur="(e) => {  form.seo_title_in = e.target.value.trim();}" />
            </a-form-model-item>
            <a-form-model-item ref="seo_description_in" label="seo描述" prop="seo_description_in" :help="formErr.seo_description_in" :validateStatus='!formErr.seo_description_in||formErr.seo_description_in==""?"":"error"' >
              <a-input type="textarea"
                       :maxLength=5000
                       v-model="form.seo_description_in"
                       @change="(e) => { formErr.seo_description_in=''}"
                       @blur="(e) => {  form.seo_description_in = e.target.value.trim();}" />
            </a-form-model-item>
            <a-form-model-item ref="keyword_in" label="关键词内容描述" prop="keyword_in" :help="formErr.keyword_in" :validateStatus='!formErr.keyword_in||formErr.keyword_in==""?"":"error"' >
              <a-input type="textarea"
                       :maxLength=5000
                       v-model="form.keyword_in"
                       @change="(e) => { formErr.keyword_in=''}"
                       @blur="(e) => {  form.keyword_in = e.target.value.trim();}" />
            </a-form-model-item>
            <a-form-model-item ref="paragraphs_in" label="产品段落描述" prop="paragraphs_in" :help="formErr.paragraphs_in" :validateStatus='!formErr.paragraphs_in||formErr.paragraphs_in==""?"":"error"' >
              <a-input type="textarea"
                       :maxLength=5000
                       v-model="form.paragraphs_in"
                       @change="(e) => { formErr.paragraphs_in=''}"
                       @blur="(e) => {  form.paragraphs_in = e.target.value.trim();}" />
            </a-form-model-item>
            <a-form-model-item ref="case_in" label="案例描述" prop="case_in" :help="formErr.case_in" :validateStatus='!formErr.case_in||formErr.case_in==""?"":"error"' >
              <a-input type="textarea"
                       :maxLength=5000
                       v-model="form.case_in"
                       @change="(e) => { formErr.case_in=''}"
                       @blur="(e) => {  form.case_in = e.target.value.trim();}" />
            </a-form-model-item>
            <a-form-model-item ref="programme_in" label="解决方案描述" prop="programme_in" :help="formErr.programme_in" :validateStatus='!formErr.programme_in||formErr.programme_in==""?"":"error"' >
              <a-input type="textarea"
                       :maxLength=5000
                       v-model="form.programme_in"
                       @change="(e) => { formErr.programme_in=''}"
                       @blur="(e) => {  form.programme_in = e.target.value.trim();}" />
            </a-form-model-item>
            <a-form-model-item ref="company_in" label="公司介绍内容" prop="company_in" :help="formErr.company_in" :validateStatus='!formErr.company_in||formErr.company_in==""?"":"error"' >
              <a-input type="textarea"
                       :maxLength=5000
                       v-model="form.company_in"
                       @change="(e) => { formErr.company_in=''}"
                       @blur="(e) => {  form.company_in = e.target.value.trim();}" />
            </a-form-model-item>
            <a-form-model-item ref="company_image_in" label="公司图片描述" prop="company_image_in" :help="formErr.company_image_in" :validateStatus='!formErr.company_image_in||formErr.company_image_in==""?"":"error"' >
              <a-input type="textarea"
                       :maxLength=5000
                       v-model="form.company_image_in"
                       @change="(e) => { formErr.company_image_in=''}"
                       @blur="(e) => {  form.company_image_in = e.target.value.trim();}" />
            </a-form-model-item>
          </template>
          <template v-if="typeId==3">
            <a-form-model-item ref="seo_title_in" label="seo标题" prop="seo_title_in" :help="formErr.seo_title_in" :validateStatus='!formErr.seo_title_in||formErr.seo_title_in==""?"":"error"' >
              <a-input type="textarea"
                       :maxLength=5000
                       v-model="form.seo_title_in"
                       @change="(e) => { formErr.seo_title_in=''}"
                       @blur="(e) => {  form.seo_title_in = e.target.value.trim();}" />
            </a-form-model-item>
            <a-form-model-item ref="seo_description_in" label="seo描述" prop="seo_description_in" :help="formErr.seo_description_in" :validateStatus='!formErr.seo_description_in||formErr.seo_description_in==""?"":"error"' >
              <a-input type="textarea"
                       :maxLength=5000
                       v-model="form.seo_description_in"
                       @change="(e) => { formErr.seo_description_in=''}"
                       @blur="(e) => {  form.seo_description_in = e.target.value.trim();}" />
            </a-form-model-item>
            <a-form-model-item ref="keyword_in" label="关键词内容描述" prop="keyword_in" :help="formErr.keyword_in" :validateStatus='!formErr.keyword_in||formErr.keyword_in==""?"":"error"' >
              <a-input type="textarea"
                       :maxLength=5000
                       v-model="form.keyword_in"
                       @change="(e) => { formErr.keyword_in=''}"
                       @blur="(e) => {  form.keyword_in = e.target.value.trim();}" />
            </a-form-model-item>
            <a-form-model-item ref="paragraphs_in" label="产品段落描述" prop="paragraphs_in" :help="formErr.paragraphs_in" :validateStatus='!formErr.paragraphs_in||formErr.paragraphs_in==""?"":"error"' >
              <a-input type="textarea"
                       :maxLength=5000
                       v-model="form.paragraphs_in"
                       @change="(e) => { formErr.paragraphs_in=''}"
                       @blur="(e) => {  form.paragraphs_in = e.target.value.trim();}" />
            </a-form-model-item>
            <a-form-model-item ref="case_in" label="案例描述" prop="case_in" :help="formErr.case_in" :validateStatus='!formErr.case_in||formErr.case_in==""?"":"error"' >
              <a-input type="textarea"
                       :maxLength=5000
                       v-model="form.case_in"
                       @change="(e) => { formErr.case_in=''}"
                       @blur="(e) => {  form.case_in = e.target.value.trim();}" />
            </a-form-model-item>
            <a-form-model-item ref="programme_in" label="解决方案描述" prop="programme_in" :help="formErr.programme_in" :validateStatus='!formErr.programme_in||formErr.programme_in==""?"":"error"' >
              <a-input type="textarea"
                       :maxLength=5000
                       v-model="form.programme_in"
                       @change="(e) => { formErr.programme_in=''}"
                       @blur="(e) => {  form.programme_in = e.target.value.trim();}" />
            </a-form-model-item>
            <a-form-model-item ref="company_in" label="公司介绍内容" prop="company_in" :help="formErr.company_in" :validateStatus='!formErr.company_in||formErr.company_in==""?"":"error"' >
              <a-input type="textarea"
                       :maxLength=5000
                       v-model="form.company_in"
                       @change="(e) => { formErr.company_in=''}"
                       @blur="(e) => {  form.company_in = e.target.value.trim();}" />
            </a-form-model-item>
            <a-form-model-item ref="cert_in" label="证书描述" prop="cert_in" :help="formErr.cert_in" :validateStatus='!formErr.cert_in||formErr.cert_in==""?"":"error"' >
              <a-input type="textarea"
                       :maxLength=5000
                       v-model="form.cert_in"
                       @change="(e) => { formErr.cert_in=''}"
                       @blur="(e) => {  form.cert_in = e.target.value.trim();}" />
            </a-form-model-item>
            <a-form-model-item ref="company_image_in" label="公司图片描述" prop="company_image_in" :help="formErr.company_image_in" :validateStatus='!formErr.company_image_in||formErr.company_image_in==""?"":"error"' >
              <a-input type="textarea"
                       :maxLength=5000
                       v-model="form.company_image_in"
                       @change="(e) => { formErr.company_image_in=''}"
                       @blur="(e) => {  form.company_image_in = e.target.value.trim();}" />
            </a-form-model-item>
          </template>
          <template v-if="typeId==4">
            <a-form-model-item ref="seo_title_in" label="seo标题" prop="seo_title_in" :help="formErr.seo_title_in" :validateStatus='!formErr.seo_title_in||formErr.seo_title_in==""?"":"error"' >
              <a-input type="textarea"
                       :maxLength=5000
                       v-model="form.seo_title_in"
                       @change="(e) => { formErr.seo_title_in=''}"
                       @blur="(e) => {  form.seo_title_in = e.target.value.trim();}" />
            </a-form-model-item>
            <a-form-model-item ref="seo_description_in" label="seo描述" prop="seo_description_in" :help="formErr.seo_description_in" :validateStatus='!formErr.seo_description_in||formErr.seo_description_in==""?"":"error"' >
              <a-input type="textarea"
                       :maxLength=5000
                       v-model="form.seo_description_in"
                       @change="(e) => { formErr.seo_description_in=''}"
                       @blur="(e) => {  form.seo_description_in = e.target.value.trim();}" />
            </a-form-model-item>
            <a-form-model-item ref="keyword_in" label="关键词内容描述" prop="keyword_in" :help="formErr.keyword_in" :validateStatus='!formErr.keyword_in||formErr.keyword_in==""?"":"error"' >
              <a-input type="textarea"
                       :maxLength=5000
                       v-model="form.keyword_in"
                       @change="(e) => { formErr.keyword_in=''}"
                       @blur="(e) => {  form.keyword_in = e.target.value.trim();}" />
            </a-form-model-item>
            <a-form-model-item ref="programme_in" label="解决方案描述" prop="programme_in" :help="formErr.programme_in" :validateStatus='!formErr.programme_in||formErr.programme_in==""?"":"error"' >
              <a-input type="textarea"
                       :maxLength=5000
                       v-model="form.programme_in"
                       @change="(e) => { formErr.programme_in=''}"
                       @blur="(e) => {  form.programme_in = e.target.value.trim();}" />
            </a-form-model-item>

          </template>
          <template v-if="typeId==5">
            <a-form-model-item ref="seo_title_in" label="seo标题" prop="seo_title_in" :help="formErr.seo_title_in" :validateStatus='!formErr.seo_title_in||formErr.seo_title_in==""?"":"error"' >
              <a-input type="textarea"
                       :maxLength=5000
                       v-model="form.seo_title_in"
                       @change="(e) => { formErr.seo_title_in=''}"
                       @blur="(e) => {  form.seo_title_in = e.target.value.trim();}" />
            </a-form-model-item>
            <a-form-model-item ref="seo_description_in" label="seo描述" prop="seo_description_in" :help="formErr.seo_description_in" :validateStatus='!formErr.seo_description_in||formErr.seo_description_in==""?"":"error"' >
              <a-input type="textarea"
                       :maxLength=5000
                       v-model="form.seo_description_in"
                       @change="(e) => { formErr.seo_description_in=''}"
                       @blur="(e) => {  form.seo_description_in = e.target.value.trim();}" />
            </a-form-model-item>
            <a-form-model-item ref="keyword_in" label="关键词内容描述" prop="keyword_in" :help="formErr.keyword_in" :validateStatus='!formErr.keyword_in||formErr.keyword_in==""?"":"error"' >
              <a-input type="textarea"
                       :maxLength=5000
                       v-model="form.keyword_in"
                       @change="(e) => { formErr.keyword_in=''}"
                       @blur="(e) => {  form.keyword_in = e.target.value.trim();}" />
            </a-form-model-item>
            <a-form-model-item ref="paragraphs_in" label="产品段落描述" prop="paragraphs_in" :help="formErr.paragraphs_in" :validateStatus='!formErr.paragraphs_in||formErr.paragraphs_in==""?"":"error"' >
              <a-input type="textarea"
                       :maxLength=5000
                       v-model="form.paragraphs_in"
                       @change="(e) => { formErr.paragraphs_in=''}"
                       @blur="(e) => {  form.paragraphs_in = e.target.value.trim();}" />
            </a-form-model-item>
            <a-form-model-item ref="case_in" label="案例描述" prop="case_in" :help="formErr.case_in" :validateStatus='!formErr.case_in||formErr.case_in==""?"":"error"' >
              <a-input type="textarea"
                       :maxLength=5000
                       v-model="form.case_in"
                       @change="(e) => { formErr.case_in=''}"
                       @blur="(e) => {  form.case_in = e.target.value.trim();}" />
            </a-form-model-item>
            <a-form-model-item ref="company_image_in" label="公司图片描述" prop="company_image_in" :help="formErr.company_image_in" :validateStatus='!formErr.company_image_in||formErr.company_image_in==""?"":"error"' >
              <a-input type="textarea"
                       :maxLength=5000
                       v-model="form.company_image_in"
                       @change="(e) => { formErr.company_image_in=''}"
                       @blur="(e) => {  form.company_image_in = e.target.value.trim();}" />
            </a-form-model-item>
          </template>
          <template v-if="typeId==6">
            <a-form-model-item ref="seo_title_in" label="seo标题" prop="seo_title_in" :help="formErr.seo_title_in" :validateStatus='!formErr.seo_title_in||formErr.seo_title_in==""?"":"error"' >
              <a-input type="textarea"
                       :maxLength=5000
                       v-model="form.seo_title_in"
                       @change="(e) => { formErr.seo_title_in=''}"
                       @blur="(e) => {  form.seo_title_in = e.target.value.trim();}" />
            </a-form-model-item>
            <a-form-model-item ref="seo_description_in" label="seo描述" prop="seo_description_in" :help="formErr.seo_description_in" :validateStatus='!formErr.seo_description_in||formErr.seo_description_in==""?"":"error"' >
              <a-input type="textarea"
                       :maxLength=5000
                       v-model="form.seo_description_in"
                       @change="(e) => { formErr.seo_description_in=''}"
                       @blur="(e) => {  form.seo_description_in = e.target.value.trim();}" />
            </a-form-model-item>
            <a-form-model-item ref="keyword_in" label="关键词内容描述" prop="keyword_in" :help="formErr.keyword_in" :validateStatus='!formErr.keyword_in||formErr.keyword_in==""?"":"error"' >
              <a-input type="textarea"
                       :maxLength=5000
                       v-model="form.keyword_in"
                       @change="(e) => { formErr.keyword_in=''}"
                       @blur="(e) => {  form.keyword_in = e.target.value.trim();}" />
            </a-form-model-item>
            <a-form-model-item ref="programme_in" label="解决方案描述" prop="programme_in" :help="formErr.programme_in" :validateStatus='!formErr.programme_in||formErr.programme_in==""?"":"error"' >
              <a-input type="textarea"
                       :maxLength=5000
                       v-model="form.programme_in"
                       @change="(e) => { formErr.programme_in=''}"
                       @blur="(e) => {  form.programme_in = e.target.value.trim();}" />
            </a-form-model-item>
            <a-form-model-item ref="advantages_in" label="优势介绍内容" prop="advantages_in" :help="formErr.advantages_in" :validateStatus='!formErr.advantages_in||formErr.advantages_in==""?"":"error"' >
              <a-input type="textarea"
                       :maxLength=5000
                       v-model="form.advantages_in"
                       @change="(e) => { formErr.advantages_in=''}"
                       @blur="(e) => {  form.advantages_in = e.target.value.trim();}" />
            </a-form-model-item>
            <a-form-model-item ref="case_in" label="案例描述" prop="case_in" :help="formErr.case_in" :validateStatus='!formErr.case_in||formErr.case_in==""?"":"error"' >
              <a-input type="textarea"
                       :maxLength=5000
                       v-model="form.case_in"
                       @change="(e) => { formErr.case_in=''}"
                       @blur="(e) => {  form.case_in = e.target.value.trim();}" />
            </a-form-model-item>
            <a-form-model-item ref="paragraphs_in" label="产品段落描述" prop="paragraphs_in" :help="formErr.paragraphs_in" :validateStatus='!formErr.paragraphs_in||formErr.paragraphs_in==""?"":"error"' >
              <a-input type="textarea"
                       :maxLength=5000
                       v-model="form.paragraphs_in"
                       @change="(e) => { formErr.paragraphs_in=''}"
                       @blur="(e) => {  form.paragraphs_in = e.target.value.trim();}" />
            </a-form-model-item>
            <a-form-model-item ref="company_in" label="公司介绍内容" prop="company_in" :help="formErr.company_in" :validateStatus='!formErr.company_in||formErr.company_in==""?"":"error"' >
              <a-input type="textarea"
                       :maxLength=5000
                       v-model="form.company_in"
                       @change="(e) => { formErr.company_in=''}"
                       @blur="(e) => {  form.company_in = e.target.value.trim();}" />
            </a-form-model-item>
            <a-form-model-item ref="cert_in" label="证书描述" prop="cert_in" :help="formErr.cert_in" :validateStatus='!formErr.cert_in||formErr.cert_in==""?"":"error"' >
              <a-input type="textarea"
                       :maxLength=5000
                       v-model="form.cert_in"
                       @change="(e) => { formErr.cert_in=''}"
                       @blur="(e) => {  form.cert_in = e.target.value.trim();}" />
            </a-form-model-item>
            <a-form-model-item ref="company_image_in" label="公司图片描述" prop="company_image_in" :help="formErr.company_image_in" :validateStatus='!formErr.company_image_in||formErr.company_image_in==""?"":"error"' >
              <a-input type="textarea"
                       :maxLength=5000
                       v-model="form.company_image_in"
                       @change="(e) => { formErr.company_image_in=''}"
                       @blur="(e) => {  form.company_image_in = e.target.value.trim();}" />
            </a-form-model-item>
          </template>
          <template v-if="typeId==7">
            <a-form-model-item ref="instruction_keyword" label="着陆页生成关键词匹配" prop="instruction_keyword" :help="formErr.instruction_keyword" :validateStatus='!formErr.instruction_keyword||formErr.instruction_keyword==""?"":"error"' >
              <a-input type="textarea"
                       :maxLength=5000
                       v-model="form.instruction_keyword"
                       @change="(e) => { formErr.instruction_keyword=''}"
                       @blur="(e) => {  form.instruction_keyword = e.target.value.trim();}" />
            </a-form-model-item>
          </template>
          <template v-if="typeId==8">
            <a-form-model-item ref="instruction_product" label="着陆页优化-产品" prop="instruction_product" :help="formErr.instruction_product" :validateStatus='!formErr.instruction_product||formErr.instruction_product==""?"":"error"' >
              <a-input type="textarea"
                       :maxLength=5000
                       v-model="form.instruction_product"
                       @change="(e) => { formErr.instruction_product=''}"
                       @blur="(e) => {  form.instruction_product = e.target.value.trim();}" />
            </a-form-model-item>
          </template>
          <template v-if="typeId==9">
            <a-form-model-item ref="instruction_product_cate" label="着陆页优化-产品分类列表描述（上）" prop="instruction_product_cate" :help="formErr.instruction_product_cate" :validateStatus='!formErr.instruction_product_cate||formErr.instruction_product_cate==""?"":"error"' >
              <a-input type="textarea"
                       :maxLength=5000
                       v-model="form.instruction_product_cate"
                       @change="(e) => { formErr.instruction_product_cate=''}"
                       @blur="(e) => {  form.instruction_product_cate = e.target.value.trim();}" />
            </a-form-model-item>
          </template>
          <template v-if="typeId==10">
            <a-form-model-item ref="instruction_product_cate_footer" label="着陆页优化-产品分类列表描述（下）" prop="instruction_product_cate_footer" :help="formErr.instruction_product_cate_footer" :validateStatus='!formErr.instruction_product_cate_footer||formErr.instruction_product_cate_footer==""?"":"error"' >
              <a-input type="textarea"
                       :maxLength=5000
                       v-model="form.instruction_product_cate_footer"
                       @change="(e) => { formErr.instruction_product_cate_footer=''}"
                       @blur="(e) => {  form.instruction_product_cate_footer = e.target.value.trim();}" />
            </a-form-model-item>
          </template>
          <a-form-model-item ref="status" label="状态" prop="status" :help="formErr.status" :validateStatus='!formErr.status||formErr.status==""?"":"error"'>
            <a-radio-group v-model="form.status"  >
              <a-radio :value="1"> 启用 </a-radio>
              <a-radio :value="2"> 停用 </a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-form-model>
        <div class="drawer-btn"  >
            <a-button type="primary" @click="onSubmit" :style="{ marginRight: '8px' }">
                确定
            </a-button>
            <a-button @click="onClose">
                取消
            </a-button>
        </div>
      </a-drawer>
    </div>
</template>

<script>
    import {submitForm,drawerConfig,validator} from "../../../../utils/utils"
    import API from "../api";
    import moment from 'moment';
    export default {
        name: "instructionForm",
        props: {
            visible:{type: Boolean,},
            title:{type: String,},
            editId:{type: [String, Number],},
            typeId:{type: [String, Number],},
        },
        data() {
            return {
                drawerConfig ,
                form: {
                  id:"",
                  type: this.typeId || 1,
                  seo_title_in:"",
                  seo_description_in:"",
                  keyword_in:"",
                  paragraphs_in:"",
                  company_in:"",
                  case_in:"",
                  cert_in:"",
                  company_image_in:"",
                  programme_in:"",
                  advantages_in:"",
                  instruction_keyword:"",
                  instruction_product:"",
                  instruction_product_cate:"",
                  instruction_product_cate_footer:"",
                  status:1,
                },
                formErr: {
                  status:'',
                  seo_title_in:"",
                  seo_description_in:"",
                  keyword_in:"",
                  paragraphs_in:"",
                  company_in:"",
                  case_in:"",
                  cert_in:"",
                  company_image_in:"",
                  programme_in:"",
                  advantages_in:"",
                  instruction_keyword:"",
                  instruction_product:"",
                  instruction_product_cate:"",
                  instruction_product_cate_footer:"",
                },
                rules: {
                  seo_title_in: [{required: true, message: "请输入内容", },{validator:(rule, value, callback)=>{this.validatePlaceholders(rule, value, callback)}  , trigger: "blur"  },],
                  seo_description_in: [{required: true, message: "请输入内容", },{validator:(rule, value, callback)=>{this.validatePlaceholders1(rule, value, callback)}  , trigger: "blur"  },],
                  keyword_in: [{required: true, message: "请输入内容", },{validator:(rule, value, callback)=>{this.validatePlaceholders2(rule, value, callback)}  , trigger: "blur"  },],
                  paragraphs_in: [{required: true, message: "请输入内容", },{validator:(rule, value, callback)=>{this.validatePlaceholders3(rule, value, callback)}  , trigger: "blur"  },],
                  company_in: [{required: true, message: "请输入内容", },{validator:(rule, value, callback)=>{this.validatePlaceholders4(rule, value, callback)}  , trigger: "blur"  },],
                  case_in: [{required: true, message: "请输入内容", },{validator:(rule, value, callback)=>{this.validatePlaceholders5(rule, value, callback)}  , trigger: "blur"  },],
                  cert_in: [{required: true, message: "请输入内容", },{validator:(rule, value, callback)=>{this.validatePlaceholders6(rule, value, callback)}  , trigger: "blur"  },],
                  company_image_in: [{required: true, message: "请输入内容", },{validator:(rule, value, callback)=>{this.validatePlaceholders7(rule, value, callback)}  , trigger: "blur"  },],
                  programme_in: [{required: true, message: "请输入内容", },{validator:(rule, value, callback)=>{this.validatePlaceholders8(rule, value, callback)}  , trigger: "blur"  },],
                  advantages_in: [{required: true, message: "请输入内容", },{validator:(rule, value, callback)=>{this.validatePlaceholders9(rule, value, callback)}  , trigger: "blur"  },],
                  instruction_keyword: [{required: true, message: "请输入内容", },{validator:(rule, value, callback)=>{this.validatePlaceholders10(rule, value, callback)}  , trigger: "blur"  },],
                  instruction_product: [{required: true, message: "请输入内容", },{validator:(rule, value, callback)=>{this.validatePlaceholders11(rule, value, callback)}  , trigger: "blur"  },],
                  instruction_product_cate: [{required: true, message: "请输入内容", },{validator:(rule, value, callback)=>{this.validatePlaceholders12(rule, value, callback)}  , trigger: "blur"  },],
                  instruction_product_cate_footer: [{required: true, message: "请输入内容", },{validator:(rule, value, callback)=>{this.validatePlaceholders13(rule, value, callback)}  , trigger: "blur"  },],

                },
                layout: {
                    labelCol: { span:4},
                    wrapperCol: { span:16},
                },
            };
        },
        watch:{
            visible:function(){

            },
            editId: function (a, b) {
                if (a != "") {
                    API.service.EDIT_DATA({id: a}).then(res => {
                      console.log(res.data)
                        let data=res.data.data.info
                        this.form = data
                        this.form.id=a
                    })
                } else {
                    this.form.id = ''

                }
            },
            typeId: function (a1) {
              this.form.type = a1
            }
        },
        mounted(){
        },
        methods: {
          validatePlaceholders(rule, value, callback) {
              if (!value) {
                  this.formErr.seo_title_in = '请输入内容'
                  callback(new Error('请输入内容'))
                  return
              }
              const requiredPlaceholders = ['{keyword}', '{industry_category}', '{language}', '{brand_keywords}']
              const missing = requiredPlaceholders.filter(placeholder => !value.includes(placeholder))
              if (missing.length > 0) {
                  const placeholderNames = {
                      '{keyword}': '{keyword}',
                      '{industry_category}': '{industry_category}',
                      '{language}': '{language}',
                      '{brand_keywords}': '{brand_keywords}',
                  }
                  const missingNames = missing.map(p => placeholderNames[p])
                  this.formErr.seo_title_in = `句式中须包含${missingNames.join('、')}`
                  callback(new Error(`句式中须包含${missingNames.join('、')}`))
              } else {
                  this.formErr.seo_title_in = ''
                  callback()
              }
          },
          validatePlaceholders1(rule, value, callback) {
            if (!value) {
              this.formErr.seo_description_in = '请输入内容'
              callback(new Error('请输入内容'))
              return
            }
            const requiredPlaceholders =  ['{keyword}', '{industry_category}', '{language}', '{core_business_goal}', '{target_audience}', '{brand_keywords}']
            const missing = requiredPlaceholders.filter(placeholder => !value.includes(placeholder))
            if (missing.length > 0) {
              const placeholderNames = {
                '{keyword}': '{keyword}',
                '{industry_category}': '{industry_category}',
                '{language}': '{language}',
                '{core_business_goal}': '{core_business_goal}',
                '{target_audience}': '{target_audience}',
                '{brand_keywords}': '{brand_keywords}',
              }
              const missingNames = missing.map(p => placeholderNames[p])
              this.formErr.seo_description_in = `句式中须包含${missingNames.join('、')}`
              callback(new Error(`句式中须包含${missingNames.join('、')}`))
            } else {
              this.formErr.seo_description_in = ''
              callback()
            }
          },
          validatePlaceholders2(rule, value, callback) {
            if (!value) {
              this.formErr.keyword_in = '请输入内容'
              callback(new Error('请输入内容'))
              return
            }
            const requiredPlaceholders = ['{keyword}', '{industry_category}', '{core_business_goal}', '{target_audience}', '{language}']
            const missing = requiredPlaceholders.filter(placeholder => !value.includes(placeholder))
            if (missing.length > 0) {
              const placeholderNames = {
                '{keyword}': '{keyword}',
                '{industry_category}': '{industry_category}',
                '{language}': '{language}',
                '{core_business_goal}': '{core_business_goal}',
                '{target_audience}': '{target_audience}',
              }
              const missingNames = missing.map(p => placeholderNames[p])
              this.formErr.keyword_in = `句式中须包含${missingNames.join('、')}`
              callback(new Error(`句式中须包含${missingNames.join('、')}`))
            } else {
              this.formErr.keyword_in = ''
              callback()
            }
          },
          validatePlaceholders3(rule, value, callback) {
            if (!value) {
              this.formErr.paragraphs_in = '请输入内容'
              callback(new Error('请输入内容'))
              return
            }
            const requiredPlaceholders = ['{keyword}', '{industry_category}', '{core_business_goal}', '{target_audience}', '{language}', '{company_name}', '{brand_keywords}']
            const missing = requiredPlaceholders.filter(placeholder => !value.includes(placeholder))
            if (missing.length > 0) {
              const placeholderNames = {
                '{keyword}': '{keyword}',
                '{industry_category}': '{industry_category}',
                '{language}': '{language}',
                '{core_business_goal}': '{core_business_goal}',
                '{target_audience}': '{target_audience}',
                '{company_name}': '{company_name}',
                '{brand_keywords}': '{brand_keywords}',
              }
              const missingNames = missing.map(p => placeholderNames[p])
              this.formErr.paragraphs_in = `句式中须包含${missingNames.join('、')}`
              callback(new Error(`句式中须包含${missingNames.join('、')}`))
            } else {
              this.formErr.paragraphs_in = ''
              callback()
            }
          },
          validatePlaceholders4(rule, value, callback) {
            if (!value) {
              this.formErr.company_in = '请输入内容'
              callback(new Error('请输入内容'))
              return
            }
            const requiredPlaceholders = ['{keyword}', '{industry_category}', '{core_business_goal}', '{target_audience}', '{language}', '{company_name}', '{brand_keywords}']
            const missing = requiredPlaceholders.filter(placeholder => !value.includes(placeholder))
            if (missing.length > 0) {
              const placeholderNames = {
                '{keyword}': '{keyword}',
                '{industry_category}': '{industry_category}',
                '{language}': '{language}',
                '{core_business_goal}': '{core_business_goal}',
                '{target_audience}': '{target_audience}',
                '{company_name}': '{company_name}',
                '{brand_keywords}': '{brand_keywords}',
              }
              const missingNames = missing.map(p => placeholderNames[p])
              this.formErr.company_in = `句式中须包含${missingNames.join('、')}`
              callback(new Error(`句式中须包含${missingNames.join('、')}`))
            } else {
              this.formErr.company_in = ''
              callback()
            }
          },
          validatePlaceholders5(rule, value, callback) {
            if (!value) {
              this.formErr.case_in = '请输入内容'
              callback(new Error('请输入内容'))
              return
            }
            const requiredPlaceholders = ['{keyword}', '{industry_category}', '{core_business_goal}', '{target_audience}', '{language}', '{company_name}', '{brand_keywords}']
            const missing = requiredPlaceholders.filter(placeholder => !value.includes(placeholder))
            if (missing.length > 0) {
              const placeholderNames = {
                '{keyword}': '{keyword}',
                '{industry_category}': '{industry_category}',
                '{language}': '{language}',
                '{core_business_goal}': '{core_business_goal}',
                '{target_audience}': '{target_audience}',
                '{company_name}': '{company_name}',
                '{brand_keywords}': '{brand_keywords}',
              }
              const missingNames = missing.map(p => placeholderNames[p])
              this.formErr.case_in = `句式中须包含${missingNames.join('、')}`
              callback(new Error(`句式中须包含${missingNames.join('、')}`))
            } else {
              this.formErr.case_in = ''
              callback()
            }
          },
          validatePlaceholders6(rule, value, callback) {
              if (!value) {
                this.formErr.cert_in = '请输入内容'
                callback(new Error('请输入内容'))
                return
              }
              const requiredPlaceholders = ['{industry_category}', '{keyword}', '{language}', '{company_name}', '{brand_keywords}']
              const missing = requiredPlaceholders.filter(placeholder => !value.includes(placeholder))
              if (missing.length > 0) {
                const placeholderNames = {
                  '{industry_category}': '{industry_category}',
                  '{keyword}': '{keyword}',
                  '{language}': '{language}',
                  '{company_name}': '{company_name}',
                  '{brand_keywords}': '{brand_keywords}',
                }
                const missingNames = missing.map(p => placeholderNames[p])
                this.formErr.cert_in = `句式中须包含${missingNames.join('、')}`
                callback(new Error(`句式中须包含${missingNames.join('、')}`))
              } else {
                this.formErr.cert_in = ''
                callback()
              }
            },
          validatePlaceholders7(rule, value, callback) {
            if (!value) {
              this.formErr.company_image_in = '请输入内容'
              callback(new Error('请输入内容'))
              return
            }
            const requiredPlaceholders = ['{industry_category}', '{keyword}', '{language}', '{company_name}', '{brand_keywords}']
            const missing = requiredPlaceholders.filter(placeholder => !value.includes(placeholder))
            if (missing.length > 0) {
              const placeholderNames = {
                '{industry_category}': '{industry_category}',
                '{keyword}': '{keyword}',
                '{language}': '{language}',
                '{company_name}': '{company_name}',
                '{brand_keywords}': '{brand_keywords}',
              }
              const missingNames = missing.map(p => placeholderNames[p])
              this.formErr.company_image_in = `句式中须包含${missingNames.join('、')}`
              callback(new Error(`句式中须包含${missingNames.join('、')}`))
            } else {
              this.formErr.company_image_in = ''
              callback()
            }
          },
          validatePlaceholders8(rule, value, callback) {
            if (!value) {
              this.formErr.programme_in = '请输入内容'
              callback(new Error('请输入内容'))
              return
            }
            const requiredPlaceholders = ['{industry_category}', '{keyword}', '{language}', '{brand_keywords}']
            const missing = requiredPlaceholders.filter(placeholder => !value.includes(placeholder))
            if (missing.length > 0) {
              const placeholderNames = {
                '{industry_category}': '{industry_category}',
                '{keyword}': '{keyword}',
                '{language}': '{language}',
                '{brand_keywords}': '{brand_keywords}',
              }
              const missingNames = missing.map(p => placeholderNames[p])
              this.formErr.programme_in = `句式中须包含${missingNames.join('、')}`
              callback(new Error(`句式中须包含${missingNames.join('、')}`))
            } else {
              this.formErr.programme_in = ''
              callback()
            }
          },
          validatePlaceholders9(rule, value, callback) {
            if (!value) {
              this.formErr.advantages_in = '请输入内容'
              callback(new Error('请输入内容'))
              return
            }
            const requiredPlaceholders = ['{industry_category}', '{keyword}', '{brand_keywords}']
            const missing = requiredPlaceholders.filter(placeholder => !value.includes(placeholder))
            if (missing.length > 0) {
              const placeholderNames = {
                '{industry_category}': '{industry_category}',
                '{keyword}': '{keyword}',
                '{brand_keywords}': '{brand_keywords}',
              }
              const missingNames = missing.map(p => placeholderNames[p])
              this.formErr.advantages_in = `句式中须包含${missingNames.join('、')}`
              callback(new Error(`句式中须包含${missingNames.join('、')}`))
            } else {
              this.formErr.advantages_in = ''
              callback()
            }
          },
          validatePlaceholders10(rule, value, callback) {
            if (!value) {
              this.formErr.instruction_keyword = '请输入内容'
              callback(new Error('请输入内容'))
              return
            }
            const requiredPlaceholders = ['{industry_category}', '{product_keywords}', '{core_business_goal}', '{target_audience}']
            const missing = requiredPlaceholders.filter(placeholder => !value.includes(placeholder))
            if (missing.length > 0) {
              const placeholderNames = {
                '{industry_category}': '{industry_category}',
                '{product_keywords}': '{product_keywords}',
                '{core_business_goal}': '{core_business_goal}',
                '{target_audience}': '{target_audience}',
              }
              const missingNames = missing.map(p => placeholderNames[p])
              this.formErr.instruction_keyword = `句式中须包含${missingNames.join('、')}`
              callback(new Error(`句式中须包含${missingNames.join('、')}`))
            } else {
              this.formErr.instruction_keyword = ''
              callback()
            }
          },
          validatePlaceholders11(rule, value, callback) {
            if (!value) {
              this.formErr.instruction_product = '请输入内容'
              callback(new Error('请输入内容'))
              return
            }
            const requiredPlaceholders = ['{product_name}', '{product_dec}', '{industry_category}', '{core_business_goal}', '{target_audience}', '{language}', '{brand_keywords}']
            const missing = requiredPlaceholders.filter(placeholder => !value.includes(placeholder))
            if (missing.length > 0) {
              const placeholderNames = {
                '{product_name}': '{product_name}',
                '{product_dec}': '{product_dec}',
                '{industry_category}': '{industry_category}',
                '{core_business_goal}': '{core_business_goal}',
                '{target_audience}': '{target_audience}',
                '{language}': '{language}',
                '{brand_keywords}': '{brand_keywords}',
              }
              const missingNames = missing.map(p => placeholderNames[p])
              this.formErr.instruction_product = `句式中须包含${missingNames.join('、')}`
              callback(new Error(`句式中须包含${missingNames.join('、')}`))
            } else {
              this.formErr.instruction_product = ''
              callback()
            }
          },
          validatePlaceholders12(rule, value, callback) {
            if (!value) {
              this.formErr.instruction_product_cate = '请输入内容'
              callback(new Error('请输入内容'))
              return
            }
            const requiredPlaceholders = ['{product_category_name}', '{product_category_dec1}', '{industry_category}', '{core_business_goal}', '{target_audience}', '{language}', '{brand_keywords}']
            const missing = requiredPlaceholders.filter(placeholder => !value.includes(placeholder))
            if (missing.length > 0) {
              const placeholderNames = {
                '{product_category_name}': '{product_category_name}',
                '{product_category_dec1}': '{product_category_dec1}',
                '{industry_category}': '{industry_category}',
                '{core_business_goal}': '{core_business_goal}',
                '{target_audience}': '{target_audience}',
                '{language}': '{language}',
                '{brand_keywords}': '{brand_keywords}',
              }
              const missingNames = missing.map(p => placeholderNames[p])
              this.formErr.instruction_product_cate = `句式中须包含${missingNames.join('、')}`
              callback(new Error(`句式中须包含${missingNames.join('、')}`))
            } else {
              this.formErr.instruction_product_cate = ''
              callback()
            }
          },
          validatePlaceholders13(rule, value, callback) {
            if (!value) {
              this.formErr.instruction_product_cate_footer = '请输入内容'
              callback(new Error('请输入内容'))
              return
            }
            const requiredPlaceholders = ['{product_category_name}', '{product_category_dec1}', '{industry_category}', '{core_business_goal}', '{target_audience}', '{language}', '{brand_keywords}']
            const missing = requiredPlaceholders.filter(placeholder => !value.includes(placeholder))
            if (missing.length > 0) {
              const placeholderNames = {
                '{product_category_name}': '{product_category_name}',
                '{product_category_dec1}': '{product_category_dec1}',
                '{industry_category}': '{industry_category}',
                '{core_business_goal}': '{core_business_goal}',
                '{target_audience}': '{target_audience}',
                '{language}': '{language}',
                '{brand_keywords}': '{brand_keywords}',
              }
              const missingNames = missing.map(p => placeholderNames[p])
              this.formErr.instruction_product_cate_footer = `句式中须包含${missingNames.join('、')}`
              callback(new Error(`句式中须包含${missingNames.join('、')}`))
            } else {
              this.formErr.instruction_product_cate_footer = ''
              callback()
            }
          },
          onClose() {
                this.$emit("changVisible", false);
                this.formErr={
                  status:'',
                  seo_title_in:"",
                  seo_description_in:"",
                  keyword_in:"",
                  paragraphs_in:"",
                  company_in:"",
                  case_in:"",
                  cert_in:"",
                  company_image_in:"",
                  programme_in:"",
                  advantages_in:"",
                  instruction_keyword:"",
                  instruction_product:"",
                  instruction_product_cate:"",
                  instruction_product_cate_footer:"",
                }
                this.form = {
                  status:1,
                  seo_title_in:"",
                  seo_description_in:"",
                  keyword_in:"",
                  paragraphs_in:"",
                  company_in:"",
                  case_in:"",
                  cert_in:"",
                  company_image_in:"",
                  programme_in:"",
                  advantages_in:"",
                  instruction_keyword:"",
                  instruction_product:"",
                  instruction_product_cate:"",
                  instruction_product_cate_footer:"",
                  type:1,
                },
                this.$refs.ruleForm.resetFields();
            },
            onSubmit() {
                let _this = this;
                this.$refs.ruleForm.validate(valid => {
                    if (valid) {
                        let url
                        let subData=JSON.parse(JSON.stringify(this.form))

                      this.form.id == '' || this.form.id == undefined ? url = API.service.SUBMIT_ADD : url = API.service.SUBMIT_EDIT

                      submitForm(url, subData).then(res => {
                        console.log(res)
                            if (res == true) {
                                this.onClose()
                            } else {
                                res.map((item, index) => {
                                    this.formErr[item.field] = item.msg
                                })
                            }
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
        },
    }
</script>

<style scoped>
.ant-input-number-input{width: 100%!important;}
form >>> .ant-form-item-label > label{
  display: block;word-break: break-word; white-space: normal;
}
form .ant-mentions, form textarea.ant-input {
  height: 200px;
}
</style>
